<template>
  <div class="foundation-report">
    <div class="auto_1280">
      <img class="logo" src="@/assets/logo.png" alt="" />
      <ul class="ul clearfix">
        <li v-for="( item, index ) in reportList" :key="index">
          <a class="report-item" :href="item.content" :download="item.title" target="_blank">
            <div class="ri_index">{{ item.indexText}}</div>
            <div class="ri_content">
              <div class="ri_title dot">{{item.title}}</div>
              <div class="more" v-if="lan === 0">了解更多</div>
              <div class="more" v-else-if="lan === 1">Learn More</div>
            </div>
          </a>
        </li>
      </ul>
      <div class="pager" v-if="reportList.length > 0">
        <span class="p_page">
          <a @click="pageIndex = ( pageIndex == 1 ? 1 : pageIndex - 1 );" class="a_prev"></a>
          <em class="num">
              <a
                v-for="( num, index ) in pageList"
                @click="pageIndex = num;"
                :key="index"
                :class="[ num == pageIndex ? 'a_cur' : '' ]"
              >{{num}}</a>
          </em>
          <a @click="pageIndex = ( pageIndex == maxPageIndex ? maxPageIndex : pageIndex + 1 );" class="a_next"></a>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FoundationReport',
  data () {
    return {
      reportList: [],
      articleTypeId: 0,
      pageList: [],
      pageIndex: 1,
      pageSize: 5,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn
    }
  },
  watch: {
    pageIndex (val, oldval) {
      if (val !== oldval) {
        this.init()
      }
    },
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      if (this.pageIndex !== 1) {
        this.pageIndex = 1
      } else {
        this.init()
      }
    }
  },
  activated () {
    this.initId()
  },
  mounted () {
    localStorage.removeItem('path')
    localStorage.removeItem('columnId')
    const self = this
    self.initId()
    self.init()
  },
  methods: {
    initId () {
      const self = this
      let menuList
      try {
        menuList = JSON.parse(localStorage.getItem('routeList'))
      } catch (e) {
        console.log(e)
      }
      const id = parseInt(self.$route.query.columnId)
      const index = self.$route.path.lastIndexOf('/')
      const path = self.$route.path.substring(index + 1, self.$route.path.length)
      menuList.forEach((item) => {
        if (id === item.id) {
          item.children.forEach((inner) => {
            if (inner.requestTo.toLowerCase() === path) {
              this.articleTypeId = inner.id
              this.$store.commit('changeId', inner.id)
            }
          })
        }
      })
      // this.$store.commit('changeId', this.articleTypeId)
    },
    init () {
      const self = this
      self.reportList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: self.articleTypeId, current: self.pageIndex, pageSize: self.pageSize, bLanguage: this.lan }, r => {
        if (r.total && r.data) {
          const { pageIndex, pageSize } = this;
          self.total = r.total
          r.data.forEach((item, index) => {
            // console.log('index', index + 1 + ((pageIndex - 1) * pageSize).padStart(2, '0'))
            item.indexText = `${index + 1 + ((pageIndex - 1) * pageSize)}`.padStart(2, '0');
            self.reportList.push(item)
          })
        }
        self.initPager()
      })
    },
    initPager () {
      const self = this
      const footerCount = 5
      self.pageList = []
      self.maxPageIndex = parseInt(self.total / self.pageSize) + (self.total % self.pageSize === 0 ? 0 : 1)
      let startPageIndex = self.pageIndex - parseInt(footerCount / 2)
      startPageIndex = startPageIndex < 1 ? 1 : startPageIndex
      for (let i = startPageIndex; i <= self.maxPageIndex; i++) {
        self.pageList.push(i)
        if (self.pageList.length >= footerCount) break
      }
    },
    download (item) {
      const id = item.id
      let path = ''
      this.$api.post('api/benefitArticle/getFilePath', { id }, r => {
        console.log(r)
        path = r.path
      })
      const a = document.createElement('a')
      a.setAttribute('href', path)
      a.setAttribute('download', item.title)
      a.click()
    }
  }
}
</script>
<style scoped>
.foundation-report{padding: 2% 0 5%;}
.foundation-report ul{margin: 0 -1.5625%;}
.foundation-report li{width: 50%;  padding: 0 1.5625%; margin: 2% 0; cursor: pointer;}

.foundation-report .logo{width: 45%; float: right;}

.foundation-report .report-item{display: flex; align-items: center; padding: 40px 0; border-bottom: 1px solid #eee;}
.foundation-report .report-item:first-of-type{ padding-top: 10px; }
.foundation-report .ri_index{width: 80px; height: 80px; text-align: center; line-height: 80px; border: 1px solid rgba(228,0,127,0.1);; margin-right: 44px; font-size: 40px; color: #E4007F; font-weight: 700;}
.foundation-report .ri_title{font-size: 26px; color: #222; margin-bottom: 18px; font-weight: 700;}

.foundation-report .more{height: 14px; line-height: 14px; display: inline-block; font-size: 16px; color: #E4007F; background: url(../../assets/a_next.png)no-repeat right center;  padding-right: 15px;}
.foundation-report li:hover .more{opacity: 1;}

@media(max-width: 960px){
  .foundation-report .more{font-size: 14px;}
}

@media(max-width: 640px){
  .foundation-report li{width: 50%;}
  .foundation-report .title{font-size: 14px;}
}


</style>
